import { useNavigateLog } from "@ch/helpers/hooks/useNavigateLog";
import type { FC } from "react";
import { Outlet } from "react-router-dom";

const AuthRootPage: FC = () => {
  useNavigateLog();

  return (
    <div className="flex flex-col items-stretch overflow-y-auto bg-white-400 lg:h-[100dvh]">
      <main className="h-full flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AuthRootPage;
